import type { MessageBrokerMultiaddrDTO } from '@/types/organization/MessageBrokerMultiaddr';

export abstract class OrganizationService {
  abstract getMessageBrokerMultiaddr(organizationId: string): Promise<MessageBrokerMultiaddrDTO>;
}
